import React, {useEffect, useMemo, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {
    Box,
    Dialog,
    IconButton,
    Button,
    Slide,
    Theme,
    Toolbar,
    Paper,
    Typography,
    Card,
    CardContent,
    CardHeader,
    CardActions,
    LinearProgress
} from "@mui/material";
import {CloseRounded} from "@mui/icons-material";
import {useTheme} from '@mui/material/styles';
import {useParams} from "react-router-dom";
import {ContainerClasses} from '../../themes/containerClasses'
import MonitorIcon from '@mui/icons-material/Monitor';
import {SearchFieldComponent} from "../../components/searchField/SearchField";
import {ListSelectorComponent} from "../../components/listSelector/ListSelector";
import {ErrorComponent} from "../../components/error/Error";
import {ListComponent} from "../../components/list/List";
import {ListViewModel,
        ListViewFilterModel,
        ActionModel} from "../../models/models";
import {SortOrderModel,
        BarChartUIPreferenceModel} from '../../models/modelsUserConfiguration';
import {setSelectedTabObject} from "../../app/globalLayoutSlice";
import {getAppName,
        getObjectName} from "../../utils/helperRouter";
import { useNavigate } from "react-router";
import { useAuth } from "../../hooks/useAuth";
import { ActionsComponent } from "../../components/actions-o/Actions";
import { SearchScreen } from "./search/Search";

export const CustomPageScreen = () => {

  let {appName, customPageName} = useParams();

  const theme = useTheme();
  const styles = ContainerClasses();
  const {accessToken, onInvalidToken} = useAuth();

  const [error, setError] = useState<string | null>(null);


  useEffect(() => {
    if(customPageName &&
       customPageName === 'search'){
         setError(null)
    } else {
      setError(`Custom page ${customPageName} not defined`)
    }

  }, [customPageName]); // eslint-disable-line react-hooks/exhaustive-deps


  return (

     <Box>
       {
         error &&
         <ErrorComponent
           errorMessage = {error}
         />
       }

       {
         customPageName &&
         customPageName === 'search' &&
         <SearchScreen/>
       }

     </Box>

);
};
